import "./AboutPage.scss"
import Header from "../../components/Header/Header"
import Footer from "../../components/Footer/Footer"
import RoverVideo from "../../components/RoverVideo/RoverVideo";
import greetings from "../../img/team-greetings.png"
import oldRoverGif from "../../img/old-rover.gif"
import oldRoverImg from "../../img/old-rover.png"
import meetup from "../../img/first-ukrainian-team.png"
import star from "../../img/asterisk.svg"
import meaning from "../../img/ucu-logo-shirt.png"
import work from "../../img/teamwork.png"
import drone from "../../img/drone-team.png"
import communication from "../../img/talk-team.png"
import explanation from "../../img/expl-team.png"


const AboutPage = () => {
    return (
        <section className="AboutPage">
            <Header/>

            <div className="AboutPage-content">
                <section className="AboutPage-greetings">
                    <img src={greetings} alt="UCU Space Robotics team"/>
                    <h2>INDOMITUS - THE STORY</h2>
                </section>

                <section className="AboutPage-beginning">
                    <div className="AboutPage-beginning-txt">
                        <h5>1/ the beginning</h5>
                        <p>The team’s history began with a small university project. During the course
                            <span> “Principles of Computer Organization”</span> in Ukrainian Catholic University,
                            4 students — Mykola Balyk, Yurii Fito, Yaryna Zabchuk and Bohdan Kolodchak — under the
                            guidance
                            of their mentor Andriy Ozhovych created their first small rover.</p>
                        <p>It was then that the idea to build something <span>much bigger</span> came to mind.</p>
                    </div>
                    <div className="AboutPage-beginning-images">
                        <img src={oldRoverGif} alt="Old Rover" className="AboutPage-beginning-images-gif"/>
                        <img src={oldRoverImg} alt="Old Rover" className="AboutPage-beginning-images-rover"/>
                    </div>
                </section>

                <section className="AboutPage-fact">
                    <img src={meetup} alt="Team meeting"/>
                    <div className="AboutPage-fact-txt">
                        <h2>FIRST UKRAINIAN TEAM</h2>
                        <p>which participates in European Rover Challenge</p>
                    </div>
                </section>

                <section className="AboutPage-meaning">
                    <img src={star} alt="Star" className="AboutPage-meaning-star"/>
                    <div className="AboutPage-meaning-content">
                        <h6>For us, this is <span>not</span> just an engineering project or a university initiative.
                        </h6>
                        <img src={meaning} alt="UCU logo T-shirt close-up"/>
                        <p>It is an opportunity to show that even during wartime, Ukrainian students are
                            <span> capable of creating </span>
                            complex technological systems, working on world-class robotics, and competing on the
                            international stage.</p>
                    </div>
                </section>

                <section className="AboutPage-pics">
                    <div className="AboutPage-pics-row">
                        <img src={work} alt="UCU Space Robotics team working"/>
                        <p className="p-orange">friendly</p>
                    </div>
                    <div className="AboutPage-pics-row">
                        <p className="p-purple">ambitious</p>
                        <img src={drone} alt="UCU Space Robotics drone team working"/>
                    </div>
                    <div className="AboutPage-pics-row">
                        <img src={communication} alt="UCU Space Robotics team communicating"/>
                        <p className="p-white">motivated</p>
                    </div>
                </section>

                <section className="AboutPage-curr">
                    <div className="AboutPage-curr-goal">
                        <h3>united by a common goal.</h3>
                        <p>a team of enthusiastic students united by an interest in space, robotics, and complex
                            technical
                            challenges.</p>
                    </div>

                    <div className="AboutPage-curr-team">
                        <div className="AboutPage-curr-team-txt">
                            <h5>2/ UCU Space Robotics</h5>
                            <p>The team is divided into several specialized sub-teams, each of which is responsible for
                                a <span>separate</span> area of work on the rover.
                                Each sub-team has a team lead and mentor who
                                coordinate
                                the work and help with technical decisions.</p>
                        </div>

                        <img src={explanation} alt="PM explanation"/>
                    </div>
                </section>

                <section className="AboutPage-ending">
                    <div className="AboutPage-ending-msg">
                        <h2>«</h2>
                        <div className="AboutPage-ending-msg-bg">
                            <p>For us, working on the rover is about engineering, hundreds of hours of collaboration,
                                evening meetings, tests, mistakes, celebrations, deadlines, and moments when you have to
                                keep going even when something doesn't work.</p>
                        </div>
                        <h2>»</h2>
                    </div>
                    <RoverVideo/>
                </section>
            </div>

            <Footer/>
        </section>
    );
}

export default AboutPage;